export const halfPI = Math.PI * 0.5
